// removed by extract-text-webpack-plugin
module.exports = {"exception":"exception--26p4ev","img":"img--1kYXaT","code":"code--3o_4CH","text":"text--1JY_cP"};